module.exports = __webpack_public_path__ + "52f0e98627e9a32c8f40124dedd41aa2.svg";